export default "__VITE_ASSET__DBpjtk7d__"